import React, { Component } from 'react'
import { Dialog } from '@sencha/ext-modern'

export default class extends Component {
	state = {
		showed: false,
		renderMe: false,
		showMe: false,
		closing: false
	}

	componentDidUpdate = () => {
		const { displayed } = this.props
		const { renderMe, closing } = this.state
		if (displayed != renderMe) {
			displayed && this.setState({ renderMe: true })
			!displayed && !closing && this.doClose()
		}
	}

	handleHide = () => {
		this.setState({ renderMe: false, closing: false })
	}

	handleShow = () => {
		this.setState({ showed: true })
	}

	doClose = () => {
		this.setState({ closing: true })
		this.tryClose()
	}

	tryClose = () => {
		const { showed } = this.state

		showed ? this.setState({ showed: false, showMe: false }) : setTimeout(this.tryClose)
	}

	render() {
		const { onInitialize, children, ...rest } = this.props
		const { renderMe, showMe } = this.state
		return renderMe &&
			< Dialog {...rest}
				displayed={showMe}
				onInitialize={obj => {
					onInitialize && onInitialize()
					this.setState({ showMe: true/* , obj  */ })
				}}
				onHide={this.handleHide}
				onShow={this.handleShow}
			>{children}</ Dialog> || null
	}
}